<lib-input-wrapper [ionItemWrap]="ionItemWrap" [addBottomMargin]="addBottomMargin">
    <div [formGroup]="form">
        <ion-select
            [label]="label"
            [value]="value"
            [multiple]="multiple"
            [interfaceOptions]="interfaceOptions"
            [placeholder]="placeholder"
            class="input input-select"
            [formControlName]="controlName"
            labelPlacement="stacked"
            [interface]="interface"
            [toggleIcon]="toggleIcon"
            [ngClass]="{
                'has-error': (submitAttempt && formInput && !formInput.valid) || errorText
            }"
            (ionChange)="onSelectChange($event)">
            <ion-select-option *ngFor="let option of options" [value]="option.value" class="select-option">
                {{ option.label }}
            </ion-select-option>
        </ion-select>

        <div *ngIf="formInput && formInput.errors && submitAttempt">
            <p *ngIf="formInput.errors['required']" class="invalid-text">Required field</p>
            <p *ngIf="!formInput.errors['required']" class="invalid-text">Please check this field again</p>
        </div>

        <div *ngIf="helperText">
            <p>{{ helperText }}</p>
        </div>

        <div class="invalid-text" *ngIf="errorText">
            <p>{{ errorText }}</p>
        </div>
    </div>
</lib-input-wrapper>
